import { actionPreset, type ActionButtonDef } from '@components/button-actions/button-actions.types';

// ── Catálogo de acciones de prospecto ──────────────────────────────
// Fuente única: cada acción se define una sola vez.
// Colores: tonos "-7" de la paleta Ant Design (contraste >=3:1 sobre blanco,
// WCAG 1.4.11 — estándar de la botonera de la plataforma).

export const PROSPECT_ACTIONS = {
  reagendar:                actionPreset('reagendar',                { icon: 'calendar',     tooltip: 'Reagendar',               color: '#d48806' }),
  'sesion-realizada':       actionPreset('sesion-realizada',         { icon: 'check-circle', tooltip: 'Sesión realizada',        color: '#389e0d',  advanceTo: 4 }),
  documentos:               actionPreset('documentos',               { icon: 'folder-open',  tooltip: 'Documentos',              color: '#d46b08' }),
  'generacion-propuesta':   actionPreset('generacion-propuesta',     { icon: 'file-text',    tooltip: 'Generación Propuesta',    color: '#722ed1',  advanceTo: 12 }),
  'autorizacion-propuesta': actionPreset('autorizacion-propuesta',   { icon: 'audit',        tooltip: 'Autorización Propuesta',  color: '#1890ff',  advanceTo: 13 }),
  'sesion-propuesta':       actionPreset('sesion-propuesta',         { icon: 'team',         tooltip: 'Sesión Propuesta',        color: '#08979c',  advanceTo: 14 }),
  'reagenda-propuesta':     actionPreset('reagenda-propuesta',       { icon: 'calendar',     tooltip: 'Reagenda Propuesta',      color: '#d48806' }),
  'propuesta-realizada':    actionPreset('propuesta-realizada',      { icon: 'check-circle', tooltip: 'Propuesta realizada',     color: '#389e0d',  advanceTo: 16 }),
  aceptacion:               actionPreset('aceptacion',               { icon: 'like',         tooltip: 'Aceptación',              color: '#389e0d',  advanceTo: 21 }),
  'vista-previa-formato':   actionPreset('vista-previa-formato',     { icon: 'snippets',     tooltip: 'Vista previa formato',    color: '#08979c' }),
  rechazo:                  actionPreset('rechazo',                  { icon: 'close-circle', tooltip: 'Rechazo',                 color: '#ff4d4f',  advanceTo: 31 }),
} as const satisfies Record<string, ActionButtonDef>;

// ── Acciones por paso/etapa ────────────────────────────────────────
const A = PROSPECT_ACTIONS;

export const STAGE_ACTIONS: Record<number, ActionButtonDef[]> = {
  2:  [A.reagendar, A['sesion-realizada']],
  3:  [A.reagendar, A['sesion-realizada']],
  11: [A['generacion-propuesta']],
  12: [A['autorizacion-propuesta']],
  13: [A['sesion-propuesta']],
  14: [A['reagenda-propuesta'], A['propuesta-realizada']],
  15: [A['reagenda-propuesta'], A['propuesta-realizada']],
  16: [A.aceptacion],
};

export const RECHAZO_ACTION: ActionButtonDef = A.rechazo;

// Derivado automáticamente del catálogo — no mantener a mano
export const ACTION_ADVANCE_MAP: Record<string, number> = Object.fromEntries(
  Object.values(PROSPECT_ACTIONS)
    .filter((a): a is ActionButtonDef & { advanceTo: number } => a.advanceTo != null)
    .map(a => [a.action, a.advanceTo]),
);
